import { stringify } from 'csv-stringify/browser/esm/sync';
import { ReportRecord } from '../../../redux/productSlice';

export const prepareClockCsvData = (recordData: ReportRecord[]) => {
  const dataToCsv = recordData
    .map((record) => {
      return record.records.map((timeRecord) => {
        return [
          timeRecord.user.username,
          timeRecord.user.name,
          timeRecord.issue.project.fullPath,
          timeRecord.issue.project.name,
          timeRecord.issue.iid,
          timeRecord.issue.title,
          timeRecord.timeSpent.toFixed(2),
          timeRecord.spentAt.toLocaleDateString(),
          timeRecord.spentAt.toLocaleTimeString(),
          timeRecord.issue.milestone?.title ?? '',
        ];
      });
    })
    .flat();
  dataToCsv.unshift([
    'AuthorUsername',
    'AuthorName',
    'ProjectFullPath',
    'Project',
    'IssueID',
    'Issue',
    'Spend',
    'Date',
    'Time',
    'Milestone',
  ]);
  return stringify(dataToCsv);
};
